import React from 'react';
import { Button } from 'react-bootstrap';
import { HiArrowNarrowLeft, HiArrowNarrowRight } from 'react-icons/hi'; // or use BsArrowLeft, IoChevronBack, etc.

export default function StepNavigation({
  onBack,
  onContinue,
  disableContinue = false,
  backLabel = 'Back',
  continueLabel = 'Continue',
  hideBack = false,
}) {
  return (
    <>
      {/* Mobile - Floating Fixed Bottom */}
      <div
        className="d-md-none position-fixed w-100 px-3"
        style={{
          bottom: '80px',
          maxWidth: '720px',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 1040,
        }}
      >
<div className="d-flex gap-2">
  {!hideBack && (
<Button
  variant="dark"
  onClick={onBack}
  className="flex-shrink-0 d-flex align-items-center gap-2 px-3"
>
  <HiArrowNarrowLeft size={18} />
  
</Button>
  )}
  <Button
    variant="dark"
    onClick={onContinue}
    disabled={disableContinue}
    className="flex-grow-1"
  >
    {continueLabel}  <HiArrowNarrowRight size={18} />

  </Button>
</div>

      </div>

      {/* Desktop - Matches Parent Card Width */}
<div className="d-none d-md-block mt-4" style={{ padding: '0 1rem' }}>
  <div
    className="d-flex gap-2"
    style={{
      maxWidth: '300px',
      marginLeft: 'auto',
      marginRight: '0',
      transform: 'translateX(-0%)', // adjust this to fine-tune position
    }}
  >
    {!hideBack && (
      <Button
        variant="secondary"
        onClick={onBack}
        className="px-4 py-3"
        style={{ minWidth: '100px' }}
      >
        {backLabel}
      </Button>
    )}
    <Button
      variant="dark"
      onClick={onContinue}
      disabled={disableContinue}
      className="px-4 py-3"
      style={{ minWidth: '140px' }}
    >
      {continueLabel}
    </Button>
  </div>
</div>
    </>
  );
}
